import { useQuery } from '@tanstack/react-query';
import { API } from 'api';

import { BroadcastifyCounty } from 'features/broadcastify/broadcastify.types';

type UseBroadcastifyCountyResponse = {
  countyIsLoading: boolean;
  countyName: string | null;
  countyUrl: string | null;
};

const fetchBroadcastifyCounty = async (
  lat: number,
  lng: number,
): Promise<BroadcastifyCounty> => {
  const urlParams = new URLSearchParams({
    lat: lat.toString(),
    lng: lng.toString(),
  });
  const result = await API.get<BroadcastifyCounty>(
    `broadcastify/county-url?${urlParams.toString()}`,
  );
  return result.data;
};

export const useBroadcastifyCounty = (
  lat: number,
  lng: number,
): UseBroadcastifyCountyResponse => {
  const result = useQuery<BroadcastifyCounty>({
    queryKey: ['broadcastifyCounty', lat, lng],
    queryFn: () => fetchBroadcastifyCounty(lat, lng),
    staleTime: Infinity,
  });

  const { data } = result;
  return {
    countyIsLoading: result.isLoading,
    countyName: data?.name ?? null,
    countyUrl: data?.url ?? null,
  };
};
